import React from 'react'
import { IoLogoWhatsapp } from "react-icons/io";
const Whatsapp = () => {
  return (
    <div className='fixed bottom-10 shadow-4xl right-1 cursor-pointer z-1000 bg-white p-1 rounded-md'><IoLogoWhatsapp className='text-[#4caf50] text-6xl'/></div>
  )
}

export default Whatsapp